import { XmlTechAudioMappingCondition } from "./xml-tech-audio-mapping-condition";
import { XmlTechAudioMappingTrack } from "./xml-tech-audio-mapping-track";

export class XmlTechAudioMapping {
  conditions: XmlTechAudioMappingCondition[] | null = null;
  tracks: XmlTechAudioMappingTrack[] | null = null;
  bypassDoNotUse: boolean | null = null;
  voRedundancyChecker: boolean | null = null;
  unshiftMutedTracks: boolean | null = null;
  hideMappingIsVo: string | null = null;
  label: string | null = null; // Used only for UI
  isAvailable: boolean = false; // Used only for UI
  iteration: number = 0; // Used only for UI
  languages: string[] | null = null; // Used only for UI
  hasAudioDescription: boolean | null = null; // Used only for UI
  constructor(init?: Partial<XmlTechAudioMapping>) {
    Object.assign(this, init);
  }
}
